<template>
  <div v-if="isSummaryAndSaveActiveLocal">
    <div class="vx-row ml-1">
      <div class="vx-col">
        <vx-card card-background="transparent" class="remove-shadow card__no-padding" style="width: 277px">
          <vx-input-group>
            <vs-button
              :disabled="true"
              size="large"
              style="color:white;"
              class="button__fully-opaque button-text__left-align remove-shadow header_button-lookalike"
              type="filled"
              color="">
              Summary:
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
    <div class="ml-0">
      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card card-background="transparent" class="mb-4 glow-effect_dark card__no-padding">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="MessageCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                size="large"
                class="w-full button-text__left-align glow-effect_primary__hover back-button"
                style="border-radius:0 7px 7px 0"
                type="filled"
                color="#262d4a"
                @click="backToPickLanguage">
                <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
                {{ selectedLanguage }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card card-background="transparent" class="mb-4 glow-effect_dark card__no-padding">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                size="large"
                class="w-full button-text__left-align glow-effect_primary__hover back-button"
                style="border-radius:0 7px 7px 0"
                type="filled"
                color="#262d4a"
                @click="backToPickGrade">
                <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
                {{ selectedGrade.name }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card card-background="transparent" class="mb-4 glow-effect_dark card__no-padding">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                  <img height="25" :src="selectedSubject.icon" />
                </div>
              </template>

              <vs-button
                size="large"
                class="w-full button-text__left-align glow-effect_primary__hover back-button"
                style="border-radius:0 7px 7px 0"
                type="filled"
                color="#262d4a"
                @click="backToPickSubject">
                <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
                {{ selectedSubject.name }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card card-background="transparent" class="mb-4 glow-effect_dark card__no-padding">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="CodesandboxIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                size="large"
                class="w-full button-text__left-align glow-effect_primary__hover back-button"
                style="border-radius:0 7px 7px 0"
                type="filled"
                color="#262d4a"
                @click="backToPickModule">
                <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
                {{ selectedModule.name }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card card-background="transparent" class="mb-4 glow-effect_dark card__no-padding">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="DiscIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                size="large"
                class="w-full button-text__left-align glow-effect_primary__hover back-button"
                style="border-radius:0 7px 7px 0"
                type="filled"
                color="#262d4a"
                @click="backToPickTopic">
                <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
                {{ selectedTopic.name }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
      </div>
    </div>
    <div class="vx-row mt-3" style="width: 270px;margin: auto;">
      <div class="vx-col">
        <vx-card class="mb-4 glow-effect_dark card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text glow-effect_dark grade-symbol input-group_prepend-slot-bg">
                <span><feather-icon class="pt-3" icon="CheckIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              size="large"
              class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
              style="border-radius:0 7px 7px 0;"
              @click="save">
              Save & Close
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isSummaryAndSaveActive: {
      type: Boolean,
      required: true
    },
    selectedLanguage: {
      type: String,
      required: false
    },
    selectedGrade: {
      required: false
    },
    selectedSubject: {
      required: false
    },
    selectedModule: {
      required: false
    },
    selectedTopic: {
      required: false
    }
  },
  data() {
    return {
      
    };
  },
  computed: {
    isSummaryAndSaveActiveLocal: {
      get() {
        return this.isSummaryAndSaveActive;
      }
    }
  },
  methods: {
    save() {
      this.$emit("saveLocation");
    },
    backToPickLanguage() {
      this.$emit("backToPickLanguage");
    },
    backToPickGrade() {
      this.$emit("backToPickGrade");
    },
    backToPickSubject() {
      this.$emit("backToPickSubject");
    },
    backToPickModule() {
      this.$emit("backToPickModule");
    },
    backToPickTopic() {
      this.$emit("backToPickTopic");
    },
  },
  mounted() {
    
  }
};
</script>